import { Vector3 } from '@babylonjs/core';
import { Grid } from '@babylonjs/gui';
import { AssetFactory, ManifestEntry } from './AssetFactory';
import manifest from './assets/manifest.json';
import { Game } from './Game';
import { GameState } from './GameState';
import { Gui } from './gui/Gui';
import { LevelConfigLoader } from './LevelConfigLoader';
export class LevelSelection {
  constructor(public game: Game) {}

  async create() {
    await Gui.createDefaultScene(
      this.game,
      {
        url: 'assets/skybox/skybox_fantasy_castle.glb',
        rotation: new Vector3(-Math.PI / 2, 0, 0),
        rotationAxis: 'y',
      },
      'Select a Level'
    );
    await Gui.createBackButton(this.game, GameState.MAIN, '🎬');

    const levels: ManifestEntry[] = [];
    AssetFactory.findManifestFiles('.json', manifest as ManifestEntry, 'levels/', levels);
    const names = await LevelConfigLoader.getLevelNames();

    await this.game.sound.createBackgroundMusic('SongwriterBallad');

    /*  const panel = this.game.gui3D.createStackPanel();
    for (const level of levels) {
      this.game.gui3D.createButton(panel, level.name, async () => {
        this.game.engine.displayLoadingUI();
        this.game.gameState = GameState.LEVEL;
        this.game.config.level = levels.indexOf(level);
        this.game.initScene();
        this.game.level = level;
        await this.game.route();
      });
    } */

    const g = this.game.gui2D.createGrid(
      'slection_grid',
      '90%',
      '40%',
      3,
      5,
      10,
      (grid: Grid, row: number, column: number, index: number) => {
        const level = levels[index];
        let key = 'test';
        let name = 'Test';
        if (level) {
          key = level.name.replace('.json', '');
          name = names[index];
        }
        const button = this.game.gui2D.createButton(
          '',
          name,
          async () => {
            this.game.sound.play('click');
            this.game.levelKey = key;
            this.game.routeTo(GameState.LEVEL);
          },
          undefined,
          Gui.backgroundAlpha
        );
        button.cornerRadius = 10;
        button.fontSize = Gui.fontSizeXXXL;

        return button;
      }
    );

    g.top = '25%';
  }
}
